var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"justify-center":"","pa-3":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }